import { render, staticRenderFns } from "./Studios.vue?vue&type=template&id=2f91467a&scoped=true&"
import script from "./Studios.vue?vue&type=script&lang=js&"
export * from "./Studios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91467a",
  null
  
)

export default component.exports